import DataUtility from "@/services/DataUtility";
import { Faskes } from "@/types";
// import UserLogin from "@/utility/User";


import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

export interface FaskesState {
  faskes: Faskes[]
}

@Module({ store, dynamic: true, namespaced: true, name: "storeFaskes" })
class FaskesStore extends VuexModule implements FaskesState {
  faskes: Faskes[] = [];

  @Mutation SET_FASKES(faskes: Faskes[]) {
    this.faskes = faskes;
  }

  @Action({ rawError: true }) act_all() {
    const dt = DataUtility.getListFaskes();
    dt.then(dt => {
      const faskes = dt
      this.SET_FASKES(faskes);
    });
  }

  @Action({ rawError: true }) getFaskesList() {
    const dt = DataUtility.getListFaskes();
    dt.then(dt => {
      const faskes = dt
      this.SET_FASKES(faskes);
    });
  }


}

export const storeFaskes = getModule(FaskesStore);
